export class ErrorForm {
  maxSize = "";
  unsupportedType = "";
  constructor(fields?: Partial<ErrorForm>) {
    Object.assign(this, fields);
  }
}

export class VideoUtils {
  static isVideoFile(fileName: string): boolean {
    const extension =
      fileName
        .split(".")
        .pop()
        ?.toLowerCase() || "";
    return ["mp4", "webm", "mov"].includes(extension);
  }

  static async getVideoDuration(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(video.duration);
      };
      video.onerror = () => {
        reject(new Error("Error loading video metadata"));
      };
      video.src = URL.createObjectURL(file);
    });
  }

  static async generateVideoThumbnail(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (!context) {
        reject(new Error("Failed to get canvas context"));
        return;
      }

      video.onloadeddata = () => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        window.URL.revokeObjectURL(video.src);
        resolve(canvas.toDataURL("image/jpeg"));
      };

      video.onerror = () => {
        // Fallback: return video icon SVG as base64 data URL
        const svg = `<svg width="30" height="36" viewBox="0 0 30 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.73212 0.857422C1.23213 0.857422 0 2.08956 0 3.58954V32.4107C0 33.9107 1.23213 35.1429 2.73212 35.1429H27.2676C28.7676 35.1429 29.9998 33.9107 29.9998 32.4107V11.7323L19.8748 0.857422L2.73212 0.857422Z" fill="#4185F7"/>
          <path d="M30.0005 11.786V12.3217H23.1434C23.1434 12.3217 19.7684 11.6253 19.8755 8.73242C19.8755 8.73242 19.9827 11.786 23.0898 11.786H30.0005Z" fill="#2468F6"/>
          <path opacity="0.5" d="M19.875 0.857422V8.67879C19.875 9.5895 20.4643 11.7859 23.1428 11.7859H29.9999L19.875 0.857422Z" fill="white"/>
          <path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M13.9996 25.3996C15.697 25.3996 17.3249 24.7253 18.5251 23.5251C19.7253 22.3249 20.3996 20.697 20.3996 18.9996C20.3996 17.3022 19.7253 15.6744 18.5251 14.4741C17.3249 13.2739 15.697 12.5996 13.9996 12.5996C12.3022 12.5996 10.6744 13.2739 9.47413 14.4741C8.27389 15.6744 7.59961 17.3022 7.59961 18.9996C7.59961 20.697 8.27389 22.3249 9.47413 23.5251C10.6744 24.7253 12.3022 25.3996 13.9996 25.3996V25.3996ZM13.6436 16.734C13.5231 16.6536 13.3831 16.6075 13.2384 16.6004C13.0938 16.5934 12.9499 16.6258 12.8222 16.6941C12.6945 16.7624 12.5877 16.8642 12.5133 16.9884C12.4389 17.1127 12.3996 17.2548 12.3996 17.3996V20.5996C12.3996 20.7444 12.4389 20.8866 12.5133 21.0108C12.5877 21.1351 12.6945 21.2368 12.8222 21.3051C12.9499 21.3734 13.0938 21.4058 13.2384 21.3988C13.3831 21.3918 13.5231 21.3456 13.6436 21.2652L16.0436 19.6652C16.1532 19.5922 16.243 19.4932 16.3051 19.3771C16.3673 19.261 16.3998 19.1313 16.3998 18.9996C16.3998 18.8679 16.3673 18.7383 16.3051 18.6222C16.243 18.506 16.1532 18.4071 16.0436 18.334L13.6436 16.734V16.734Z" fill="white"/>
          </svg>
          `;
        const base64Svg = "data:image/svg+xml;base64," + btoa(svg);
        resolve(base64Svg);
      };

      video.src = URL.createObjectURL(file);
      video.currentTime = 1; // Capture frame at 1 second
    });
  }
}
